import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NotifyDialogService } from '../services/notify-dialog.service';

export const errorHandingInterceptor: HttpInterceptorFn = (req, next) => {
  const notifyDialogService = inject(NotifyDialogService);
  return next(req).pipe(
    catchError((err: unknown) => {
      let title = 'Error';
      let message = 'Ha ocurrido un error';

      if (err instanceof HttpErrorResponse) {
        const payload = err.error as any;
        const detail = payload?.detail;
        if (detail) {
          title = detail.error ?? title;
          message = detail.hint ?? message;
        } else if (typeof payload === 'string') {
          message = payload;
        } else if (payload?.message) {
          message = payload.message;
        } else if (err.message) {
          message = err.message;
        }
      } else if (err instanceof Error) {
        message = err.message || message;
      }

      notifyDialogService.openDialog(title, message);
      return throwError(() => err);
    })
  );
};
